
import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import { IApiLink } from "@/types"
import AssetBookingView, { IGetAssetBookingViewDto } from './AssetBookingView';

export interface IGetAssetBookingViewsDto {
    assets: IGetAssetBookingViewDto[]
    links: IApiLink[]
}

export default class AssetBookingViews {
    items: AssetBookingView[]
    linkGetAssignmentAssetInfo?: IApiLink
    linkGetBookingsForSelectedAsset?: IApiLink
    linkGetAdditionalLmidsToAssign?: IApiLink

    constructor(dto: IGetAssetBookingViewsDto) {
        this.items = dto.assets.map(item => new AssetBookingView(item))

        this.linkGetAssignmentAssetInfo = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.assignmentAssetInfo && lnk.rel === ApiLinkRel.self)
        this.linkGetBookingsForSelectedAsset = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.bookingForSelectedAssets && lnk.rel === ApiLinkRel.all)
        this.linkGetAdditionalLmidsToAssign = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.additionalLmidsToAssign && lnk.rel === ApiLinkRel.all)
    }
}
